import { RiskLevel } from "@/model/RiskLevel";
import StaffordshireLogo from "@/assets/regions/staffordshire_stars_logo.png";
import LogoIncreasing from "@/assets/regions/DrinkCoach-logo.svg";
const DefaultBanner = {
    rawCopy: "For local alcohol advice and support service details, <u>click here</u>.",
    logoLink: "https://humankindcharity.org.uk/service/staffordshire-treatment-and-recovery-service"
};
const LowerRisk = {
    rawCopy: "<strong>Keep up the good work!</strong>",
    logoLink: ""
};
const IncreasingRisk = {
    rawCopy: `For Increasing Risk scores we recommend you cut down your drinking. <u>Click here to
        book a free online DrinkCoach Appointment</u>.`,
    logoLink: "https://drinkcoach.bookinglive.com/book/add/p/17"
};
const HigherRisk = {
    rawCopy: `For Higher Risk scores we recommend you cut down your drinking. <u>Click here to
        book a free online DrinkCoach Appointment</u>.`,
    logoLink: "https://drinkcoach.bookinglive.com/book/add/p/17"
};
const HighRisk = {
    rawCopy: "For high risk scores we recommend you speak to a health professional.<br>" +
        "For local advice and support service details, <u>click here</u>.",
    logoLink: "https://humankindcharity.org.uk/service/staffordshire-treatment-and-recovery-service/"
};
export default {
    name: "Staffordshire",
    displayName: "Staffordshire",
    regionDescription: "Staffordshire (excluding Stoke)",
    logo: {
        file: StaffordshireLogo,
        width: 600,
        height: 169
    },
    logoIncreasing: {
        file: LogoIncreasing,
        width: 439,
        height: 223
    },
    logoHigher: {
        file: LogoIncreasing,
        width: 439,
        height: 223
    },
    hasFreeAppointments: true,
    zoomLevel: 9,
    showServiceInfoOnResultsSummaryPage: true,
    bannerInfo: {
        default: DefaultBanner,
        [RiskLevel.Lower]: LowerRisk,
        [RiskLevel.Increasing]: IncreasingRisk,
        [RiskLevel.Higher]: HigherRisk,
        [RiskLevel.High]: HighRisk
    },
    regions: [
        "Cannock Chase",
        "East Staffordshire",
        "Lichfield",
        "Newcastle-under-Lyme",
        "South Staffordshire",
        "Stafford",
        "Staffordshire Moorlands",
        "Tamworth",
    ],
    clinics: [
        {
            name: "Staffordshire Treatment and Recovery Service (STARS)",
            description: "Contact ${name} on ${phone} for more information",
            phone: ["01785 270080"],
            showAtRiskLevel: [RiskLevel.High],
            isPrimaryProvider: true,
            hideFromResults: true,
        },
        {
            name: "DrinkCoach Online Coaching Service",
            showAtRiskLevel: [RiskLevel.Increasing, RiskLevel.Higher],
            alwaysShowFirst: true,
            tagline: "Daytime, evening and weekend appointments available.<br>" +
                "People that live in Staffordshire (excluding Stoke-on-Trent) are eligible" +
                " for up to 6 free Online Coaching sessions to help reduce their drinking. " +
                "The service is free and confidential. Get support to cut down or take a " +
                "break from drinking. <a href='https://drinkcoach.bookinglive.com/book/add/p/17' target='_blank'>Book here</a>.",
            alwaysShowInResults: true,
            website: "https://drinkcoach.org.uk/book-online-appointment"
        },
        {
            name: "Staffordshire Treatment and Recovery Service (STARS) - NORTH",
            description: "hide",
            address: "John O Gaunt (JOG), Pool Dam, Newcastle under Lyme, ST5 2RR",
            location: {
                lat: 53.0103521,
                lng: -2.2331336,
            },
            phone: ["01782 639856"],
            email: "humankindstarsnorth@nhs.net",
            isPrimaryProvider: true,
            website: "https://humankindcharity.org.uk/service/staffordshire-treatment-and-recovery-service/",
            times: [
                {
                    title: "Opening times:",
                    info: "Appointment only - via telephone or email",
                    times: {
                        monday: [{ start: 900, end: 1700 }],
                        tuesday: [{ start: 900, end: 1700 }],
                        wednesday: [{ start: 900, end: 1700 }],
                        thursday: [{ start: 900, end: 1700 }],
                        friday: [{ start: 900, end: 1700 }]
                    }
                }
            ],
        },
        {
            name: "Staffordshire Treatment and Recovery Service (STARS) - WEST",
            description: "Contact ${name}",
            address: "10 Browning Street, Stafford, ST16 3AT",
            location: {
                lat: 52.8121853,
                lng: -2.1226372,
            },
            phone: ["01785 270080"],
            email: "humankindstarswest@nhs.net",
            isPrimaryProvider: true,
            website: "https://humankindcharity.org.uk/service/staffordshire-treatment-and-recovery-service/",
            times: [
                {
                    title: "Opening times:",
                    info: "Appointment only - via telephone or email",
                    times: {
                        monday: [{ start: 900, end: 1700 }],
                        tuesday: [{ start: 900, end: 1700 }],
                        wednesday: [{ start: 900, end: 1700 }],
                        thursday: [{ start: 900, end: 1700 }],
                        friday: [{ start: 900, end: 1700 }]
                    }
                }
            ],
        },
        {
            name: "Staffordshire Treatment and Recovery Service (STAR) - EAST",
            description: "Contact ${name}",
            address: "150 Station Street, Burton, DE14 1BG",
            phone: ["01283 741053"],
            location: {
                lat: 52.8048201,
                lng: -1.6376179,
            },
            email: "humankindstarseast@nhs.net",
            isPrimaryProvider: true,
            website: "https://humankindcharity.org.uk/service/staffordshire-treatment-and-recovery-service/",
            times: [
                {
                    title: "Opening times:",
                    info: "Appointment only - via telephone or email",
                    times: {
                        monday: [{ start: 900, end: 1700 }],
                        tuesday: [{ start: 900, end: 1700 }],
                        wednesday: [{ start: 900, end: 1700 }],
                        thursday: [{ start: 900, end: 1700 }],
                        friday: [{ start: 900, end: 1700 }]
                    }
                }
            ],
        },
        {
            name: "T3 STARS Young People's Service",
            description: "Contact ${name}",
            address: "Suite 1, 7-8 Mill Street, Stafford, ST16 2AJ",
            location: {
                lat: 52.8051614,
                lng: -2.1197395,
            },
            tagline: "<ul><li>You're up to 20 years old</li>" +
                "<li>You live in Staffordshire (excluding Stoke-on-Trent)</li>" +
                "<li>You’re worried about either your drug and alcohol use or someone else&apos;s</li></ul>",
            phone: ["01785241393"],
            email: "t3stars.stafford@humankindcharity.org.uk",
            isPrimaryProvider: true,
            website: "https://humankindcharity.org.uk/service/t3-stars-young-peoples-service/",
            times: [
                {
                    title: "Opening times:",
                    times: {
                        monday: [{ start: 900, end: 1700 }],
                        tuesday: [{ start: 900, end: 1700 }],
                        wednesday: [{ start: 900, end: 1700 }],
                        thursday: [{ start: 900, end: 1700 }],
                        friday: [{ start: 900, end: 1700 }]
                    }
                }
            ],
        },
    ]
};
//# sourceMappingURL=Staffordshire.js.map